<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h2>Справочники</h2>
      </v-flex>
      <v-flex>
        <v-list>
          <v-list-item
                  v-for="link in links"
                  :key="link.title"
                  :to="link.url"
          >
            <v-list-item-action>
              <v-icon>{{link.icon}}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-text="link.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      links: [
        {
          title: 'КБК',
          icon: 'mdi-table',
          url: '/gis_gmp/reference_tables/kbk'
        }
      ]
    }
  }
}

</script>

<style>

</style>
